import React from "react";
import { useTranslation } from "react-i18next";
import { Settings2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { CircleButton } from "@/components/custom/circle";
import {
  TooltipContent,
  TooltipProvider,
  useTooltipProps,
} from "@/components/custom/tooltip";
import { useTable, useTableSettings } from "../data-table-context";
import { ColumnManagerPanel } from "./column-manager-panel";

/**
 * The gear next to the pagination controls. Renders nothing unless the table declared a
 * `tableKey`; otherwise opens the column manager as a modal over the table, which keeps updating
 * behind it as columns are toggled.
 */
export function ColumnManager() {
  const settings = useTableSettings();
  const table = useTable();
  const { t } = useTranslation();
  const tooltipProps = useTooltipProps();
  const [open, setOpen] = React.useState(false);

  if (!settings?.enabled || !table) {
    return null;
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <CircleButton
          data-component="data-table-column-manager"
          size="sm"
          type="button"
          aria-label={t("manageColumns")}
          {...tooltipProps}
          data-tooltip-content={t("manageColumns")}
        >
          <Settings2 className="size-5" />
        </CircleButton>
      </DialogTrigger>
      <DialogContent
        aria-describedby={undefined}
        className="md:max-w-md"
        data-component="data-table-column-manager-dialog"
      >
        <TooltipProvider>
          <DialogHeader className="mb-2">
            <DialogTitle>{t("columns")}</DialogTitle>
          </DialogHeader>
          <ColumnManagerPanel
            table={table}
            onReset={settings.reset}
            isResetting={settings.isResetting}
          />
          <TooltipContent />
        </TooltipProvider>
      </DialogContent>
    </Dialog>
  );
}
